import scrollToElement from '../utils/scrollToElement';
import cardDragEndHandler from '../Drag/cardDragEndHandler';
import Logger from '../../../../../../../../../utility/services/Logger';

export default (params) => {
  const {
    e,
    snackBar,
    nodeProps: { editor, node },
    collapse,
    setCollapse,
    setSnackBar,
    dragOverCords,
  } = params;

  e.stopPropagation();

  if (snackBar && snackBar.errorCode === 'drag') {
    const { target: el } = e;
    scrollToElement(el);
    return;
  }

  try {
    cardDragEndHandler({
      e,
      editor,
      node,
      collapse,
      dragType: 'ROLE',
      setCollapse,
      dragOverCords,
    });
  } catch (err) {
    Logger.LogError(err);
    setSnackBar('error');
  }
};
